export default __webpack_public_path__ + "static/media/loader.cb5f1de6.svg";